import React, { useState } from 'react'
import {
  Card,
  CardContent,
  Typography,
  Box,
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
} from '@mui/material'
import { Bar } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

const FunnelChart: React.FC = () => {
  const [period, setPeriod] = useState('30d')

  const handlePeriodChange = (event: SelectChangeEvent) => {
    setPeriod(event.target.value)
  }

  // Mock data - in a real app, this would be fetched based on the period
  const getFunnelData = () => {
    const baseData = {
      '7d': { multiplier: 0.25 },
      '30d': { multiplier: 1 },
      '90d': { multiplier: 3 },
    }

    const multiplier = baseData[period as keyof typeof baseData]?.multiplier || 1

    return {
      labels: ['Ad Clicks', 'Messages', 'Qualified', 'Booked'],
      datasets: [
        {
          label: 'Funnel',
          data: [
            Math.floor(1200 * multiplier),
            Math.floor(840 * multiplier),
            Math.floor(420 * multiplier),
            Math.floor(126 * multiplier),
          ],
          backgroundColor: [
            'rgba(59, 130, 246, 0.8)', // Blue
            'rgba(16, 185, 129, 0.8)', // Green
            'rgba(245, 158, 11, 0.8)', // Yellow
            'rgba(139, 92, 246, 0.8)', // Purple
          ],
          borderColor: [
            'rgba(59, 130, 246, 1)',
            'rgba(16, 185, 129, 1)',
            'rgba(245, 158, 11, 1)',
            'rgba(139, 92, 246, 1)',
          ],
          borderWidth: 2,
          borderRadius: 8,
        },
      ],
    }
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: 'white',
        bodyColor: 'white',
        borderColor: 'rgba(255, 255, 255, 0.2)',
        borderWidth: 1,
        cornerRadius: 8,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          color: 'rgba(0, 0, 0, 0.1)',
        },
        ticks: {
          color: '#6b7280',
        },
      },
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: '#6b7280',
        },
      },
    },
  }

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" component="h3" fontWeight="bold">
            Conversion Funnel
          </Typography>
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <Select value={period} onChange={handlePeriodChange}>
              <MenuItem value="7d">Last 7 days</MenuItem>
              <MenuItem value="30d">Last 30 days</MenuItem>
              <MenuItem value="90d">Last 90 days</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ height: 300 }}>
          <Bar data={getFunnelData()} options={options} />
        </Box>
      </CardContent>
    </Card>
  )
}

export default FunnelChart
